export default __webpack_public_path__ + "3dae18d929b9fb9634dddc74405c11a3.png";